export enum SessionStoreKey {
    Common = 'DWS-common',
    EticketList = 'DWS-eticketList',
    EticketListTTL = 'DWS-eticketList-ttl',
    Interest = 'DWS-interest',
    AnalyticsData = 'DWS-analytics-data',
}
